import type {
  AttributesFor,
  BodyByPath,
  QueryParamsByPath,
  ResponseByPath,
  SchemaAttributes,
} from '@@/api/types.js'

export type UserAttributes = SchemaAttributes<'User'>

// TODO: should we add a 'NURSE' role?
export type UserWorkRole = NonNullable<UserAttributes['work_role']>

/**
 * User work roles as defined in the API schema
 */
export const USER_WORK_ROLES = {
  Veterinarian: 'VET',
  Support: 'SUPPORT',
  Administrative: 'ADMINISTRATIVE',
  Technician: 'TECHNICAL',
} as const satisfies Record<string, UserWorkRole>

export type SimpleUserAttributes = SchemaAttributes<'SimpleUser'>

export const API_USERS_URL = '/{provet_id}/api/users'
export type UsersListResponse = ResponseByPath<'get', typeof API_USERS_URL>
export type UsersListQueryParams = QueryParamsByPath<
  'get',
  typeof API_USERS_URL
>
export type UsersCreateBody = BodyByPath<'post', typeof API_USERS_URL>
export type UsersCreateResponse = ResponseByPath<'post', typeof API_USERS_URL>
export type CreateUser = AttributesFor<UsersCreateBody['data']> & {
  permission_group_id: string
}

export const API_USERS_DETAIL_URL = '/{provet_id}/api/users/{id}'
export type UsersPatchBody = BodyByPath<'patch', typeof API_USERS_DETAIL_URL>
export type UsersUpdateResponse = ResponseByPath<
  'patch',
  typeof API_USERS_DETAIL_URL
>
export type UpdateUser = AttributesFor<UsersPatchBody['data']> & {
  permission_group_id: string
}

export const API_USERS_STAFF_URL = '/{provet_id}/api/users/staff'
export type UsersStaffListQueryParams = QueryParamsByPath<
  'get',
  typeof API_USERS_STAFF_URL
>
export type UsersStaffListResponse = ResponseByPath<
  'get',
  typeof API_USERS_STAFF_URL
>

export const USER_PERMISSIONS_URL =
  '/{provet_id}/api/users/{parent_lookup_user}/department_permissions'

export type UserPermissionsResponse = ResponseByPath<
  'post',
  typeof USER_PERMISSIONS_URL
>

export const USER_PERMISSIONS_UPDATE_URL =
  '/{provet_id}/api/users/{parent_lookup_user}/department_permissions/{id}'

export type UserPermissionsUpdateResponse = ResponseByPath<
  'patch',
  typeof USER_PERMISSIONS_UPDATE_URL
>
